import React, { useEffect, useState } from 'react'
import { BsPencil } from 'react-icons/bs'
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import styles from './BDT_Bus.module.css'
import ChartLoader from '../../Shared/Loader';

function BDT_Table_Bus(props) {
    const { title, apiEnd, gloablfilter, setGloablfilter } = props
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [tableData, setTableData] = useState([])
    const [packType, setPackType] = useState("A")

    useEffect(() => {
        loadHighestCellIR()
    }, [packType, gloablfilter])


    function loadHighestCellIR() {
        fetchData(
            {
                url: API_URL_MAIN + `battery_digital_twin/${apiEnd}`,
                body: { packType, filterdata: gloablfilter },
            },
            (data) => {
                setTableData(data)
            }
        );
    }

    const setGlobalFilter = (vinNo) => {
        setGloablfilter(prev => ({ ...prev, pageSelected: 2, VIN_NUM: [vinNo] }))
    }

    return (
        <div className="col col-12 col-sm-12 col-md-4 col-lg-4 gap-0">
            <div className={`rounded-3 px-1 pb-0 ${styles.table_card}`}>
                <div className={`row pt-3 ${styles.table_label_container}`}>
                    <div className="col-md-12 col-sm-6 col-lg-7 align-content-center text-center">
                        <div className="" style={{fontSize:"13px"}}>{title}</div>
                    </div>
                    <div className="col-md-12 col-sm-6 col-lg-5 align-content-center text-center">
                        <select className={`form-select-sm form-select d-inline-block ${styles.form_select}`} aria-label="Default select example" onChange={(e) => setPackType(e.target.value)} value={packType}>
                            <option value="A">Pack A</option>
                            <option value="B">Pack B</option>
                            <option value="C">Pack C</option>
                            <option value="D">Pack D</option>
                        </select>
                    </div>
                </div>
                <div className={`${styles.bdt_table}`}>
                    <table className="table table-striped">
                        <thead className={`${styles.bg_light_blue} sticky-top`}>
                            <tr>
                                <th scope="col" className='border border-0 text-center'>Vin</th>
                                <th scope="col" className='border border-0 text-center'>{title == "Lowest SoH VINs" ? "Soh" : title == "Highest Cell Temp VINs" ? "Temp" : "RUL(cycle)"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                               isLoading? <ChartLoader /> :tableData?.length ?
                                    tableData?.map((x, index) => {
                                        return (
                                            <tr key={index} className='' >
                                                <td scope="row" className={`text-center table-cell ${styles.cursor_pointer}`} onClick={() => setGlobalFilter(x?.key?.vehicleId)}>{x?.key?.vehicleId}
                                                </td>
                                                <td scope="row" className='text-center table-cell' >
                                                    <span span className={`badge  rounded-pill ${styles.BDT_badge}`}>{x?.Min_SOH_Min ? Math.floor(x?.Min_SOH_Min.value) : x?.Max_Temperature_Max ? Math.floor(x?.Max_Temperature_Max.value) : x?.Pack_RUL ? Math.floor(x?.Pack_RUL.value) : ""} {title == "Lowest SoH VINs" ? "%" : title == "Highest Cell Temp VINs" ? <>&#8451;</> : ""}</span>
                                                </td>
                                            </tr>
                                        )
                                    }) :
                                    !isLoading ? <tr><td colSpan={6} className='text-center table-cell' > No Data found</td></tr> : <></>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default BDT_Table_Bus
